'use strict';

angular.module('mean.projects').factory('Lot', ['$filter',
  function($filter) {
    var number = null;
    var phase = null;
    var plan = null;
    var reverse = null;
    var color_scheme = null;
    var revision = null;
    var revisions = [];
    var scheduled = null;
    var start_date = null;
    var complete = null;
    var active_options = [];

    //constructor
    function Lot(obj) {
        console.log('Lot constructor');
        this.number = obj.number;
        this.phase = obj.phase;
        this.plan = obj.plan;
        this.reverse = obj.reverse;
        this.color_scheme = obj.color_scheme;
        this.revision = obj.revision;
        this.revisions = obj.revisions;
        this.scheduled = obj.scheduled;
        this.start_date = obj.start_date;
        this.complete = obj.complete;
        this.active_options = obj.active_options;
    }

    //public prototypes
    Lot.prototype.addRevision = function(rev, trade) {
        return this.revisions.push({
            revision: rev,
            trade: trade
        });
    };


    // Lot.number = angular.copy(number);

    // Lot.build = function(data) {
    //     console.log('figure this one out');
    // }

    return Lot;
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/lot.js